import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { media } from "../../data/navigationData";
import SEO from "../../components/SEO";
import ScrollDepthTracker from "../../components/ScrollDepthTracker";

export default function JPMorganArticle() {
  const jpmorganSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "JP Morgan Healthcare Conference",
    "url": "https://www.thrombio.com.au/media/jpmorgan",
    "mainEntity": {
      "@type": "Organization",
      "name": "Thrombio",
      "url": "https://www.thrombio.com.au/",
      "logo": "https://www.thrombio.com.au/thromBioInvert.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@thrombio.com.au"
      },
      "sameAs": [
        "https://www.linkedin.com/company/thrombioholdings"
      ]
    },
    "about": {
      "@type": "Event",
      "name": "J.P. Morgan Healthcare Conference",
      "description": "ThromBio CEO Peter Bush attending the J.P. Morgan Healthcare Conference in San Francisco."
    }
  };

  return (
    <>
      <SEO
        title="J.P. Morgan Healthcare Conference"
        description="Strong Start to 2025: ThromBio at JPM Healthcare Conference in San Francisco! CEO Peter Bush connects with investors and strategic partners."
        keywords={['J.P. Morgan Healthcare Conference', 'JPM', 'Healthcare Conference', 'Investment', 'Strategic Partners', 'Peter Bush']}
        ogImage="/jpmhealthcareconferencefeb20251.webp"
        schema={jpmorganSchema}
      />
      <ScrollDepthTracker pageCategory="media" pageName="jpmorgan" />

      <div className="bg-primary">
        <div className="page-width px-6 md:px-20 pt-[18px] pb-8">
          <nav className="flex items-center gap-2 font-sans text-[2rem] font-normal leading-[2.3rem]" aria-label="Breadcrumb">
            <Link to="/media" className="text-white hover:text-primary-red transition-colors">
              Media
            </Link>
            <span className="mx-1 text-white">/</span>
            <span className="text-[#5C95A4]">J.P. Morgan Healthcare Conference</span>
          </nav>
        </div>
        
        <div className="page-width px-6 md:px-20 pt-24 pb-16">
          <div className="text-[#C3EEFD] text-[4rem] font-bold leading-[4.8rem] tracking-[.16rem]">
            The J.P. Morgan Healthcare Conference
          </div>
        </div>

        <div className="page-width px-6 md:px-20 pb-16">
          <div className="mb-16 flex justify-center">
            <img 
              src="/jpmhealthcareconferencefeb20251.webp"
              alt="16 January 2025 The J.P. Morgan Healthcare Conference" 
              className="max-w-full h-auto rounded-lg"
            />
          </div>

          <div className="flex flex-col gap-8">
            <p className="text-white font-sans text-[2.4rem] leading-[3.8rem] tracking-wide">
              ThromBio CEO, Peter Bush, kicked off the year by attending the J.P. Morgan Healthcare Conference 2025 in San Francisco—one of the most influential gatherings in biotech and life sciences.
            </p>
            
            <p className="text-white font-sans text-[2.4rem] leading-[3.8rem] tracking-wide">
              With our lead, TBO-309, progressing in two clinical trials and plans to initiate global studies in the coming year, this was a valuable opportunity to connect with investors, strategic partners, and industry leaders who share our vision for advancing thrombosis treatment.
            </p>
            
            <p className="text-white font-sans text-[2.4rem] leading-[3.8rem] tracking-wide">
              JPM Week reaffirmed the growing interest in innovative therapies addressing unmet need in stroke and cardiovascular disease, and ThromBio is proud to be at the forefront of this mission.
            </p>
            
            <p className="text-white font-sans text-[2.4rem] leading-[3.8rem] tracking-wide">
              If we didn't get a chance to connect during the conference, we'd love to continue the conversation—reach out to explore collaboration opportunities!
            </p>
            
            <div className="mt-8">
              <a 
                href="https://www.linkedin.com/posts/thrombioholdings_strong-start-to-2025-thrombio-at-jpm-healthcare-activity-7295313187011186688-Wacm"
                target="_blank"
                rel="noreferrer"
                className="text-white text-[2rem] leading-[3.8rem] underline flex gap-6 items-center hover:text-primary-blue transition-colors"
              >
                Open in LinkedIn 
                <img src="/linkedinicon.svg" alt="LinkedIn icon" className="w-8 h-8" />
              </a>
            </div>
          </div>
        </div>
        <SeriesNavigation
          items={media}
          currentSlug="jpmorgan"
          basePath="/media"
        />
      </div>
    </>
  );
}